import React, { lazy, Suspense } from 'react';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';
const LoadableRedux = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "exclusive_transaction_history" */ './TransactionHistoryModal/redux/TransactionHistoryModuleLoader')));
const LoadableModal = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "exclusive_transaction_history" */ './TransactionHistoryModal')));
const TransactionHistoryModalLoadable = (props)=>/*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "SellerModalLoadable"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(LoadingIndicator, {
            view: 'llama',
            withOverlay: true,
            usePortal: true
        })
    }, /*#__PURE__*/ React.createElement(LoadableRedux, null), /*#__PURE__*/ React.createElement(LoadableModal, props)));
TransactionHistoryModalLoadable.displayName = 'TransactionHistoryModalLoadable';
export default TransactionHistoryModalLoadable;
